import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Icon, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip } from "@mui/material";
import TablePagination from '@mui/material/TablePagination';
import TableFooter from '@mui/material/TableFooter';
import { useLocation, useNavigate } from "react-router-dom";
import TablePaginationActions from "@mui/material/TablePagination/TablePaginationActions";
import Loading from "components/Loading";
import { useDeleteAdsMutation } from "App/services/adsServiceApi";
import AdsFormDialogue from "./components/AdsFormDialogue";
import { useGetAllProviderAdsQuery } from "App/services/adsServiceApi";
import parse from 'html-react-parser';
import AdsEditFormDialogue from "./components/AdsEditFormDialogue";

const useAllData = (data) => {
    // const allSubCategoryQuery = useGetAllSubCategoryQuery({ refetchOnFocus: false });
    const byCatIdQuery = useGetAllProviderAdsQuery(data, { refetchOnFocus: false });

    const [result, setResult] = useState({
        data: null,
        isLoading: true,
        isError: false,
        error: null,
    });

    useEffect(() => {
        if (data !== null) {
            setResult({
                data: byCatIdQuery.data,
                isLoading: byCatIdQuery.isLoading,
                isError: byCatIdQuery.isError,
                error: byCatIdQuery.error,
            });
        }
    }, [data, byCatIdQuery]);

    return result;
};


function Ads() {
    const [open, setOpen] = React.useState(false);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
    const [deleteId, setDeleteId] = useState(null);
    const navigate = useNavigate();



    const location = useLocation();
    const data = location.state || {};

    const { data: ads, isLoading, isFetching, isError, error } = useAllData(data.data);
    const [deleteAds] = useDeleteAdsMutation();

   


    if (isLoading || isFetching) {
        return <Loading />;
    }

    // Delete Botton and Delete Dialog Box work

    const handleDeleteAds = async () => {

        try {
           
            await deleteAds(deleteId).unwrap();
            setDeleteDialogOpen(false);
            setDeleteId(null);
            if (ads.length === 1) {
                window.location.reload(); 
              } else {
                
                refetchAds();
              }

        } catch (error) {

            console.error("Failed to delete Ads:", error);
        }
    };

    const handleDeleteConfirmation = (adsId) => {
        setDeleteId(adsId);
        setDeleteDialogOpen(true);
    };



    const handleCloseDeleteDialog = () => {
        setDeleteDialogOpen(false);
        setDeleteId(null);
    };



    // Pagination System

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };





    return (ads ?

        // check category under any subcategory show
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={6} pb={3}>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card>
                            <MDBox
                                mx={2}
                                mt={-3}
                                py={3}
                                px={2}
                                variant="gradient"
                                bgColor="info"
                                borderRadius="lg"
                                coloredShadow="info"
                                display="flex"
                                alignItems="center"
                                justifyContent="space-between"
                            >
                                <MDTypography variant="h6" color="white">
                                    Ads
                                </MDTypography>
                                <AdsFormDialogue/>
                            </MDBox>
                            <TableContainer>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell sx={{paddingX:10}}>Ads Name</TableCell>
                                            <TableCell>Ads Id</TableCell>
                                            <TableCell sx={{ textAlign: 'right', paddingRight: 20 }}>Action</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {(rowsPerPage > 0
                                            ? ads && ads.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                            : ads
                                        ).map((ads) => (

                                            <TableRow key={ads.id} >

                                                <TableCell sx={{paddingX:10}} >{ads.adName}</TableCell>

                                                <TableCell >{ads.content}</TableCell>
                                                
                                                <TableCell sx={{ textAlign: 'right', paddingRight: 17 }}>
                                                    <Tooltip title="Edit">
                                                        <IconButton aria-label="edit">
                                                            <AdsEditFormDialogue adsEdit={ads} />
                                                        </IconButton>
                                                    </Tooltip>
                                                    <Tooltip title="Delete">
                                                        <IconButton aria-label="delete"
                                                            onClick={() => handleDeleteConfirmation(ads.id)}
                                                        >
                                                            <Icon>delete</Icon>

                                                            {/* <Delete subcategory={subcategory.id}/> */}
                                                        </IconButton>

                                                    </Tooltip>
                                                </TableCell>
                                               
                                            </TableRow>
                                        ))}
                                    </TableBody>


                                    {/* pagination */}


                                    <TableFooter >

                                        <TableRow  >
                                            <TablePagination
                                                rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                                                colSpan={3}
                                                count={ads.length}
                                                rowsPerPage={rowsPerPage}
                                                page={page}
                                                SelectProps={{
                                                    inputProps: {
                                                        'aria-label': 'rows per page',
                                                    },
                                                    native: true,
                                                }}                                               
                                                onPageChange={handleChangePage}
                                                onRowsPerPageChange={handleChangeRowsPerPage}
                                                ActionsComponent={TablePaginationActions}
                                            />
                                        </TableRow>
                                    </TableFooter>
                                </Table>
                            </TableContainer>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
            {/* <Footer /> */}


            {/* Delete Dialog Box Open */}

            <Dialog
                open={deleteDialogOpen}
                onClose={handleCloseDeleteDialog}
                sx={{ textAlign: 'center' }}
            >
                <DialogTitle>Confirm Delete</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to delete this Ads Id
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDeleteDialog} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={handleDeleteAds} style={{ color: 'red' }}>
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
        </DashboardLayout>
        :

        // not Available any subcategory show only Head components 

        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={6} pb={3}>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card>
                            <MDBox
                                mx={2}
                                mt={-3}
                                py={3}
                                px={2}
                                variant="gradient"
                                bgColor="info"
                                borderRadius="lg"
                                coloredShadow="info"
                                display="flex"
                                alignItems="center"
                                justifyContent="space-between"
                            >
                                <MDTypography variant="h6" color="white">
                                    Ads
                                </MDTypography>
                                <AdsFormDialogue />
                            </MDBox>
                            <TableContainer>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Name</TableCell>
                                            <TableCell sx={{ textAlign: "left" }}>Action</TableCell>
                                        </TableRow>
                                    </TableHead>
                                </Table>
                            </TableContainer>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
        </DashboardLayout>
    );
}

export default Ads;
